import Modal, { ModalRef } from '@ui-components-3/ui/lib/components/Modal'
import { ForwardedRef, forwardRef } from 'react'
import { COOKIE_POLICY_LINK, PRIVACY_POLICY_LINK } from 'util/constants'

type CookiesAgreementProps = {
  onConfirm: () => void
}

const CookiesAgreementDialog = forwardRef(({ onConfirm }: CookiesAgreementProps, ref: ForwardedRef<ModalRef>) => {
  return (
    <Modal
      showHeaderCloseButton={false}
      className="max-w-[85vw] md:max-w-3xl"
      footer={({ close }) => (
        <div className="flex flex-col gap-4 md:flex-row md:justify-between">
          <button
            type="button"
            className="btn btn-neutral order-2 w-full md:order-1"
            onClick={() => {
              onConfirm()
              close()
            }}
          >
            Reject All (Except for Essential Cookies)
          </button>

          <button
            type="button"
            className="btn btn-neutral order-1 w-full md:order-2"
            onClick={() => {
              onConfirm()
              close()
            }}
          >
            Accept All Cookies
          </button>
        </div>
      )}
      label="We value your privacy"
      size={'custom'}
      ref={ref}
    >
      <p className="typography-body">
        We use some essential cookies that are necessary to make this service work. We also use cookies and other
        technologies to enhance user experience and analyze performance on our website. You can exercise your choices
        regarding these technologies using the buttons below. For more information, please see our{' '}
        <a href={PRIVACY_POLICY_LINK} className="text-link-primary" target="_blank" rel="noreferrer">
          Privacy Policy
        </a>{' '}
        and{' '}
        <a href={COOKIE_POLICY_LINK} className="text-link-primary" target="_blank" rel="noreferrer">
          Cookie Policy
        </a>
        .
      </p>
    </Modal>
  )
})

export default CookiesAgreementDialog
